// extracted by mini-css-extract-plugin
module.exports = {"Section___centered":"ContentSection_Section___centered__OdvUT"};